import {
	brandPrimary,
	brandPrimaryDark,
	brandPrimaryHoverTint,
	destructive,
	gray3,
	gray4,
	titles,
	white,
} from '@Styles/colors';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';
import { CssSelectors } from '../../../../../../../web/styles/styles';

const { spacing, common, colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		padding: spacing.lg,
		paddingTop: spacing.xs,
	},
	headerSection: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-end',
		marginBottom: spacing.md,
	},
	titleSection: {
		flex: 1,
	},
	title: {
		fontSize: 24,
		fontWeight: 600,
		color: brandPrimary,
		marginBottom: spacing.xs,
	},
	subtitle: {
		color: gray4,
	},
	clientCredentialsModal: {
		...CssSelectors.allDescendants(
			{
				width: 600,
			},
			'.modal-overlay-content'
		),
	},
	modalTitle: {
		fontSize: 20,
		fontWeight: 600,
		color: brandPrimary,
	},
	modalError: {
		color: colors.danger.main,
		fontSize: '14px',
		verticalAlign: 'text-top',
	},
	modalDangerIcon: {
		verticalAlign: 'text-top',
	},
	settingGroup: {
		backgroundColor: white,
		borderRadius: common.borderRadius,
		marginBottom: spacing.md,
		overflow: 'hidden',
		border: common.border,
		boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
		':last-child': {
			marginBottom: spacing.none,
		},
	},
	settingRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: spacing.sm,
		padding: `${spacing.md}px ${spacing.lg}px`,
		borderBottom: common.border,
		':last-child': {
			borderBottom: 'none',
		},
	},
	settingRowSubSetting: {
		paddingLeft: spacing.xxl,
		backgroundColor: gray4 + '10', // Slight gray tint to show nesting
	},
	settingGroupHeader: {
		padding: `${spacing.md}px ${spacing.lg}px`,
		borderBottom: common.border,
		backgroundColor: brandPrimaryHoverTint,
	},
	settingGroupTitle: {
		fontSize: 16,
		fontWeight: 600,
		color: titles,
		margin: spacing.none,
	},
	settingHeader: {
		flex: 1,
	},
	settingTitle: {
		fontSize: 14,
		fontWeight: 500,
		color: titles,
		margin: spacing.none,
	},
	settingSubtitle: {
		fontSize: 13,
		color: gray4,
		marginTop: spacing.xs,
	},
	settingControls: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		gap: spacing.md,
		minWidth: 250,
		width: '50%',
	},
	settingContent: {
		width: 400,
	},
	settingError: {
		color: destructive,
		fontSize: 16,
	},
	buttonGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	confirmationDialogDescription: {
		fontSize: 14,
		color: gray3,
		marginBottom: spacing.sm,
		textAlign: 'center',
		maxWidth: 600,
	},
	readOnlyField: {
		fontSize: 14,
		color: brandPrimaryDark,
		textAlign: 'right',
		overflow: 'hidden',
		textOverflow: 'clip',
		whiteSpace: 'nowrap',
		width: '100%',
	},
	userMapReadOnlyField: {
		fontSize: 14,
		color: brandPrimaryDark,
		textAlign: 'left',
	},
	readOnlyFieldOverflow: {
		':hover': {
			cursor: 'pointer',
		},
	},
	editableField: {
		width: '40%',
	},
	copyToClipboardButton: {
		width: 250,
	},
	comboboxChipsNoWrap: {
		padding: 0,
		border: 0,
		background: 'transparent',
		boxShadow: 'none',
		marginTop: spacing.sm,
	},
	moreChipsLink: {
		background: 'none',
		border: 'none',
		color: brandPrimary,
		fontSize: 14,
		fontWeight: 500,
		cursor: 'pointer',
		padding: `${spacing.xs}px ${spacing.sm}px`,
		':hover': {
			textDecoration: 'underline',
		},
	},
	moreChipsPopover: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: spacing.xs,
		maxWidth: 400,
		maxHeight: 300,
		overflowY: 'auto',
	},
	comboboxTriggerWrapper: {
		width: '100%',
		position: 'relative' as const,
	},
	comboboxTrigger: {
		display: 'inline-flex',
		justifyContent: 'space-between',
		flex: 1,
		alignItems: 'center',
	},
	comboboxContentWithInput: {
		paddingTop: 0,
	},
	comboboxInputWrapper: {
		padding: spacing.sm,
	},
	comboboxList: {
		maxHeight: 300,
		overflowY: 'auto' as const,
	},
	numberInput: {
		padding: `${spacing.sm}px ${spacing.md}px`,
		border: common.border,
		borderRadius: common.borderRadius,
		fontSize: 14,
		textAlign: 'right' as const,
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
	},
	numberInputSmall: {
		width: 80,
	},
	comboboxItemDescription: {
		fontSize: 12,
		color: gray3,
		marginTop: 2,
	},
	dynamicSectionModalContent: {
		padding: spacing.lg,
		minWidth: 400,
	},
	dynamicSectionModalTitle: {
		fontSize: 18,
		fontWeight: 600,
		color: titles,
		margin: 0,
		marginBottom: spacing.xs,
	},
	dynamicSectionModalSubtitle: {
		fontSize: 14,
		color: gray3,
		marginTop: 0,
		marginBottom: spacing.md,
	},
	dynamicSectionModalActions: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: spacing.md,
	},
	dualTagWarning: {
		backgroundColor: colors.warning.light,
		borderRadius: common.borderRadius,
		padding: `${spacing.sm}px ${spacing.md}px`,
		marginTop: spacing.sm,
	},
});
